import { Link } from "react-router-dom";
import { projects } from "@/content/site";
import { BrowserFrame, TextLink, Label } from "./Ui";
import { Reveal, Clip } from "./Motion";

export function Deliverables({ items }) {
  return (
    <ul className="flex flex-wrap gap-2">
      {items.map((d) => <li key={d} className="border border-ink/20 px-3 py-1.5 font-mono text-[12px]">{d}</li>)}
    </ul>
  );
}

export function ProjectRow({ p, i }) {
  const flip = i % 2 === 1;
  return (
    <article className="grid items-center gap-8 border-t border-ink/15 py-14 md:py-20 lg:grid-cols-12 lg:gap-12" data-testid={`project-row-${p.slug}`}>
      <Clip className={`lg:col-span-8 ${flip ? "lg:order-2" : ""}`}>
        <Link to={`/realisations/${p.slug}`} className="group block" aria-label={`Étude de cas ${p.name}`}>
          <div className="transition-transform duration-700 group-hover:-translate-y-1">
            <BrowserFrame src={p.shots.home} alt={`Page d'accueil du site ${p.name}`} label={p.domain || p.name} />
          </div>
        </Link>
      </Clip>
      <Reveal className={`lg:col-span-4 ${flip ? "lg:order-1" : ""}`}>
        <Label>({String(i + 1).padStart(2, "0")}) {p.category}</Label>
        <h3 className="display mt-4 text-[2.4rem] leading-none md:text-[3rem]">{p.name}</h3>
        <p className="mt-3 font-mono text-[13px] text-mute">{p.place}</p>
        <p className="mt-6 leading-relaxed text-mute">{p.context}</p>
        <div className="mt-6"><Deliverables items={p.deliverables} /></div>
        <div className="mt-8 flex flex-wrap gap-6">
          <TextLink to={`/realisations/${p.slug}`} testid={`project-case-${p.slug}`}>Voir l'étude de cas</TextLink>
          {p.url && <TextLink href={p.url} target="_blank" rel="noopener noreferrer" testid={`project-site-${p.slug}`}>Voir le site</TextLink>}
        </div>
      </Reveal>
    </article>
  );
}

export default function ProjectRows() {
  return <div>{projects.map((p, i) => <ProjectRow key={p.slug} p={p} i={i} />)}</div>;
}
